<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.name="{ header, item, value: v }">
      <router-link
        :to="header.getRoute(item)"
        v-text="v"
      />
    </template>

    <template #item.owner="{ header, item, value: v }">
      <router-link
        v-if="v"
        :to="header.getRoute(item)"
        v-text="v.full_name"
      />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/Files/table-headers'

import BTable from '@/components/common/BTable.vue'

export default {
  name: 'BTableFiles',
  components: {
    BTable,
  },
  inheritAttrs: false,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
    list: {
      type: Array,
    },
  },
}
</script>
